import React from "react";

const RefundPolicy = () => {
  return (
    <div className="policy-container">
      <h1>Refund Policy</h1>
      <p>
        At <strong>Oza Clothing Company</strong>, customer satisfaction is our top priority. 
        We take great care to ensure that our apparel is of premium quality, delivered in perfect condition, 
        and meets your expectations. Please read our refund and return policy carefully before placing an order.
      </p>

      <h2>1. No Refund on Worn or Used Products</h2>
      <p>
        For hygiene and quality reasons, <strong>refunds or returns are not accepted</strong> 
        once clothing items have been worn, washed, or altered in any way.
      </p>

      <h2>2. Damaged, Defective, or Wrong Product</h2>
      <p>
        If you receive a product that is <strong>damaged, defective, or incorrect</strong>, 
        you may request a replacement or refund under the following conditions:
      </p>
      <ul>
        <li>Notify us within <strong>48 hours</strong> of delivery.</li>
        <li>Provide clear pictures of the damaged/defective/incorrect item and packaging.</li>
        <li>The product must be unworn, unwashed, and in its original packaging with tags for return eligibility.</li>
      </ul>

      <h2>3. Non-Refundable Situations</h2>
      <ul>
        <li>Orders delayed due to courier or logistics partners (outside our control).</li>
        <li>Change of mind after purchase.</li>
        <li>Items worn, washed, or altered by the customer.</li>
        <li>Damage caused due to improper care or storage by the customer.</li>
      </ul>

      <h2>4. Refund Process</h2>
      <p>
        Once your refund request is approved, the amount will be credited to your original payment method 
        within <strong>7–10 business days</strong>.
      </p>

      <h2>5. Exchanges</h2>
      <p>
        We only replace items if they are defective, damaged, or incorrect. 
        To request an exchange, please contact us immediately with your order details and proof.
      </p>

      <h2>6. Contact Us</h2>
      <p>For refund or return queries, please reach out to us at:</p>
      <ul>
        <li>
          <strong>Phone:</strong> 9082043375
        </li>
        <li>
          <strong>Email:</strong> ozaclothingcompany@yahoo.com
        </li>
        <li>
          <strong>Address:</strong> Mumbai, Maharashtra, 400101, India
        </li>
      </ul>
    </div>
  );
};

export default RefundPolicy;
